import React from "react";
import { useUpdateLayerIcons } from "api";
import { Row } from "@tanstack/react-table";
import Loader from "@/components/ui/Loader";
import { Checkbox } from "../../../@/components/ui/checkbox";
import { LayerIcon } from "../types";

interface DataTableRowProps {
  row: Row<LayerIcon>;
  entityKey: string;
  type?: string;
}

export const DataTableRowOpt = ({ row, entityKey }: DataTableRowProps) => {
  const data = row.original;

  const { handleUpdate, isMutating } = useUpdateLayerIcons(data.id);

  const onCheckedChange = (value: boolean | "indeterminate") => {
    if (isMutating) return;
    handleUpdate(entityKey, !value, false);
  };

  return (
    <div className="flex justify-center items-center">
      {isMutating ? (
        <Loader className="w-4 h-4" />
      ) : (
        <>
          <Checkbox
            className="border-black/60 data-[state=checked]:border-primary"
            checked={!data[entityKey]}
            onCheckedChange={onCheckedChange}
          />
        </>
      )}
    </div>
  );
};
